import { useDispatch, useSelector } from 'react-redux';

import {
  Drawer,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverline,
} from '@frontend/components';

import { pluralize } from 'utils/stringUtils';

import { BulkEditDiscountsDrawerForm } from './BulkEditDiscountsDrawerForm';
import * as actions from './data/actions';
import { getIsOpen, getComponents } from './data/reducer';

export const BulkEditDiscountsDrawer = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(getIsOpen);
  const components = useSelector(getComponents);

  const onClose = () => dispatch(actions.close());

  return (
    <Drawer isOpen={isOpen} onClose={onClose}>
      <DrawerContent>
        <DrawerHeader>
          <DrawerOverline>
            {pluralize('Quote Item', components.length)}
          </DrawerOverline>
          Update Discounts
          <DrawerCloseButton />
        </DrawerHeader>
        <BulkEditDiscountsDrawerForm />
      </DrawerContent>
    </Drawer>
  );
};
